module.exports = __webpack_public_path__ + "img/attendance.01ee5c0d.svg";